module.exports = __webpack_public_path__ + "img/tabungan_pensiunan_nasional.e52fdfff.svg";